module.exports = __webpack_public_path__ + "img/SIKH PURPLE.345b874.svg";